import { render, staticRenderFns } from "./EmployeePreview.vue?vue&type=template&id=3a3e8bac&"
import script from "./EmployeePreview.vue?vue&type=script&lang=ts&"
export * from "./EmployeePreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports